import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-support',
    templateUrl: './support.page.html',
    styleUrls: ['./support.page.scss'],
})
export class SupportPage implements OnInit {
    constructor() {}

    ngOnInit() {}
}
